import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { defineComponent as _defineComponent } from 'vue';
import { ImpactSolutionKind } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'SolutionKindChip',
  props: {
    kind: null
  },
  setup: function setup(__props) {
    var props = __props;
    var KIND_META = _defineProperty(_defineProperty(_defineProperty({}, ImpactSolutionKind.Product, {
      labelKey: 'PRODUCT',
      icon: 'mdi-cube-outline',
      style: {
        backgroundColor: '#dbeafe',
        color: '#1e40af'
      }
    }), ImpactSolutionKind.Service, {
      labelKey: 'SERVICE',
      icon: 'mdi-account-cog-outline',
      style: {
        backgroundColor: '#ccfbf1',
        color: '#115e59'
      }
    }), ImpactSolutionKind.Hybrid, {
      labelKey: 'HYBRID',
      icon: 'mdi-swap-horizontal',
      style: {
        backgroundColor: '#fef3c7',
        color: '#92400e'
      }
    });
    var kindMeta = computed(function () {
      var _KIND_META$props$kind;
      if (!props.kind) return null;
      return (_KIND_META$props$kind = KIND_META[props.kind]) !== null && _KIND_META$props$kind !== void 0 ? _KIND_META$props$kind : null;
    });
    return {
      __sfc: true,
      KIND_META: KIND_META,
      props: props,
      kindMeta: kindMeta
    };
  }
});